import script from "./violation-input-disabled.vue?vue&type=script&setup=true&lang=js"
export * from "./violation-input-disabled.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__